module.exports = __webpack_public_path__ + "img/sq4.111698d2.png";